// src/hooks/useCompaniesData.js
import { useMemo } from "react";
import usePaginatedApiData from "../../../../hooks/usePaginatedApiData";
import { buildPaginationParams, toCsvParam } from "../../../../utils/pagination";

export default function useCompaniesData({
  page,
  pageSize,
  searchTerm,
  filters,
  orderBy,
  orderDirection,
  endpoint = "/user-companies/",
}) {
  const params = useMemo(
    () =>
      buildPaginationParams({
        page,
        pageSize,
        search: searchTerm || undefined,
        industry: toCsvParam(filters?.industry),
        sector: toCsvParam(filters?.sector),
        city: filters?.city || undefined,
        county: filters?.county || undefined,
        employees: filters?.employees || undefined,
        pipeline_stage: filters?.pipeline_stage || undefined,
        lease_expiring: filters?.lease_expiring || undefined,
        sort_by: orderBy,
        sort_dir: orderDirection,
      }),
    [
      page,
      pageSize,
      searchTerm,
      filters?.industry,
      filters?.sector,
      filters?.city,
      filters?.county,
      filters?.employees,
      filters?.pipeline_stage,
      filters?.lease_expiring,
      orderBy,
      orderDirection,
    ],
  );

  const {
    data: companies,
    totalCount,
    loading,
    error,
    refetch,
  } = usePaginatedApiData({
    endpoint,
    params,
    errorMessage: "Failed to load companies",
  });

  return {
    companies,
    totalCount,
    loading,
    error,
    refetch,
  };
}
